import React from "react";
import Section from "./Section";
import * as content from "../content";

export default function Hero() {
  const { hero: h } = content;
  return (
    <Section id="top" className="section--hero">
      <p className="eyebrow">{h.kicker}</p>
      <h1 className="display">{h.names}</h1>
      <p className="lede">{h.tagline}</p>
      <p className="hero-meta">
        <span>{h.dateLine}</span>
        <span className="dot" aria-hidden="true">
          ·
        </span>
        <span>{h.placeLine}</span>
      </p>
      <a className="scroll-hint" href="#gallery">
        {h.scrollCue}
        <span className="scroll-hint__line" aria-hidden="true" />
      </a>
    </Section>
  );
}
